var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./TimedSlot.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2e125a30!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TimedSlot.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TimedSlot/TimedSlot.vue
// module id = 638
// module chunks = 0